<template>
    <WindowDialog :isOpen="props.isOpen" title="Notes">
        <div id="toolbar" class="btn-save flex gap-2 items-center">
            <div class="flex gap-1 items-center">
                <button @click="savePlayNotes" class="border-0 h-[16px]">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        fill="currentColor"
                        class="bi bi-floppy"
                        viewBox="0 0 16 16"
                    >
                        <path d="M11 2H9v3h2z" />
                        <path
                            d="M1.5 0h11.586a1.5 1.5 0 0 1 1.06.44l1.415 1.414A1.5 1.5 0 0 1 16 2.914V14.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13A1.5 1.5 0 0 1 1.5 0M1 1.5v13a.5.5 0 0 0 .5.5H2v-4.5A1.5 1.5 0 0 1 3.5 9h9a1.5 1.5 0 0 1 1.5 1.5V15h.5a.5.5 0 0 0 .5-.5V2.914a.5.5 0 0 0-.146-.353l-1.415-1.415A.5.5 0 0 0 13.086 1H13v4.5A1.5 1.5 0 0 1 11.5 7h-7A1.5 1.5 0 0 1 3 5.5V1H1.5a.5.5 0 0 0-.5.5m3 4a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V1H4zM3 15h10v-4.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5z"
                        />
                    </svg>
                </button>
            </div>
            <span style="font-size: 0.6rem">{{ state.saveText }}</span>
            <button
                @click="editor.chain().focus().toggleBold().run()"
                class="border-0 h-[16px] flex items-center"
                :class="{ 'is-active': editor.isActive('bold') }"
            >
                <img
                    class="w-[16px] h-[16px]"
                    src="/default-images/notes/bold-icon.svg"
                    alt="Bold"
                />
            </button>
            <button
                @click="editor.chain().focus().toggleItalic().run()"
                class="border-0 h-[16px] flex items-center"
                :class="{ 'is-active': editor.isActive('italic') }"
            >
                <img
                    class="w-[16px] h-[16px]"
                    src="/default-images/notes/italic-icon.svg"
                    alt="Bold"
                />
            </button>
            <button
                @click="editor.chain().focus().toggleUnderline().run()"
                class="border-0 h-[16px] flex items-center"
                :class="{ 'is-active': editor.isActive('underline') }"
            >
                <img
                    class="w-[16px] h-[16px]"
                    src="/default-images/notes/underline-icon.svg"
                    alt="Bold"
                />
            </button>
            <button
                @click="editor.chain().focus().toggleStrike().run()"
                class="border-0 h-[16px] flex items-center"
                :class="{ 'is-active': editor.isActive('strike') }"
            >
                <img
                    class="w-[16px] h-[16px]"
                    src="/default-images/notes/strike-icon.svg"
                    alt="Bold"
                />
            </button>
            <button
                @click="editor.chain().focus().toggleBulletList().run()"
                class="border-0 h-[16px] flex items-center"
                :class="{ 'is-active': editor.isActive('bulletList') }"
            >
                <img
                    class="w-[16px] h-[16px]"
                    src="/default-images/notes/bulletlist-icon.svg"
                    alt="Bold"
                />
            </button>
            <button
                @click="editor.chain().focus().toggleOrderedList().run()"
                class="border-0 h-[16px] flex items-center"
                :class="{ 'is-active': editor.isActive('orderedList') }"
            >
                <img
                    class="w-[16px] h-[16px]"
                    src="/default-images/notes/orderderlist-icon.svg"
                    alt="Bold"
                />
            </button>
            <button
                class="border-0 h-[16px] flex items-center"
                @click="
                    editor
                        .chain()
                        .focus()
                        .insertTable({ rows: 3, cols: 3, withHeaderRow: true })
                        .run()
                "
            >
                <img
                    class="w-[16px] h-[16px]"
                    src="/default-images/notes/table-icon.svg"
                    alt="Bold"
                />
            </button>
            <button class="border-0 h-[16px] flex items-center">
                <input
                    class="absolute opacity-0 w-[16px] h-[16px]"
                    type="color"
                    @input="
                        editor
                            .chain()
                            .focus()
                            .setColor($event.target.value)
                            .run()
                    "
                    :value="editor.getAttributes('textStyle').color"
                    data-testid="setBackgroundColor"
                />
                <svg
                    class="w-[16px] h-[16px]"
                    viewBox="0 0 16 16"
                    fill="none"
                    :stroke="editor.getAttributes('textStyle').color || '#000'"
                >
                    <line
                        class="stroke-[2px]"
                        x1="3"
                        x2="15"
                        y1="15"
                        y2="15"
                    ></line>
                    <polyline
                        class="fill-[none] stroke-[1px]"
                        points="5.5 11 9 3 12.5 11"
                    ></polyline>
                    <line
                        class="fill-none stroke-[1px]"
                        x1="11.63"
                        x2="6.38"
                        y1="9"
                        y2="9"
                    ></line>
                </svg>
            </button>
            <button class="border-0 h-[16px] flex items-center">
                <input
                    class="opacity-0 absolute opacity-0 w-[16px] h-[16px]"
                    type="color"
                    @input="
                        editor
                            .chain()
                            .focus()
                            .setMark('textStyle', {
                                backgroundColor: $event.target.value,
                            })
                            .run()
                    "
                    :value="editor.getAttributes('textStyle').backgroundColor"
                />
                <svg
                    class="w-[16px] h-[16px]"
                    viewBox="0 0 18 18"
                    fill="none"
                    :stroke="
                        editor.getAttributes('textStyle').backgroundColor ||
                        'gray'
                    "
                >
                    <g class="ql-fill ql-color-label" style="">
                        <polygon
                            points="6 6.868 6 6 5 6 5 7 5.942 7 6 6.868"
                        ></polygon>
                        <rect height="1" width="1" x="4" y="4"></rect>
                        <polygon
                            points="6.817 5 6 5 6 6 6.38 6 6.817 5"
                        ></polygon>
                        <rect height="1" width="1" x="2" y="6"></rect>
                        <rect height="1" width="1" x="3" y="5"></rect>
                        <rect height="1" width="1" x="4" y="7"></rect>
                        <polygon
                            points="4 11.439 4 11 3 11 3 12 3.755 12 4 11.439"
                        ></polygon>
                        <rect height="1" width="1" x="2" y="12"></rect>
                        <rect height="1" width="1" x="2" y="9"></rect>
                        <rect height="1" width="1" x="2" y="15"></rect>
                        <polygon
                            points="4.63 10 4 10 4 11 4.192 11 4.63 10"
                        ></polygon>
                        <rect height="1" width="1" x="3" y="8"></rect>
                        <path
                            d="M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z"
                        ></path>
                        <path
                            d="M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z"
                        ></path>
                        <path
                            d="M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z"
                        ></path>
                        <rect height="1" width="1" x="12" y="2"></rect>
                        <rect height="1" width="1" x="11" y="3"></rect>
                        <path d="M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z"></path>
                        <rect height="1" width="1" x="2" y="3"></rect>
                        <rect height="1" width="1" x="6" y="2"></rect>
                        <rect height="1" width="1" x="3" y="2"></rect>
                        <rect height="1" width="1" x="5" y="3"></rect>
                        <rect height="1" width="1" x="9" y="2"></rect>
                        <rect height="1" width="1" x="15" y="14"></rect>
                        <polygon
                            points="13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174"
                        ></polygon>
                        <rect height="1" width="1" x="13" y="7"></rect>
                        <rect height="1" width="1" x="15" y="5"></rect>
                        <rect height="1" width="1" x="14" y="6"></rect>
                        <rect height="1" width="1" x="15" y="8"></rect>
                        <rect height="1" width="1" x="14" y="9"></rect>
                        <path
                            d="M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z"
                        ></path>
                        <rect height="1" width="1" x="14" y="3"></rect>
                        <polygon
                            points="12 6.868 12 6 11.62 6 12 6.868"
                        ></polygon>
                        <rect height="1" width="1" x="15" y="2"></rect>
                        <rect height="1" width="1" x="12" y="5"></rect>
                        <rect height="1" width="1" x="13" y="4"></rect>
                        <polygon
                            points="12.933 9 13 9 13 8 12.495 8 12.933 9"
                        ></polygon>
                        <rect height="1" width="1" x="9" y="14"></rect>
                        <rect height="1" width="1" x="8" y="15"></rect>
                        <path
                            d="M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z"
                        ></path>
                        <rect height="1" width="1" x="5" y="15"></rect>
                        <path
                            d="M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z"
                        ></path>
                        <rect height="1" width="1" x="11" y="15"></rect>
                        <path
                            d="M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z"
                        ></path>
                        <rect height="1" width="1" x="14" y="15"></rect>
                        <rect height="1" width="1" x="15" y="11"></rect>
                    </g>
                    <polyline
                        class="ql-stroke"
                        points="5.5 13 9 5 12.5 13"
                    ></polyline>
                    <line
                        class="ql-stroke"
                        x1="11.63"
                        x2="6.38"
                        y1="11"
                        y2="11"
                    ></line>
                </svg>
            </button>
        </div>

        <div id="editor-container">
            <editor-content :editor="editor" />
        </div>
    </WindowDialog>
</template>

<script setup>
import { EditorContent, useEditor } from "@tiptap/vue-3";
import { StarterKit } from "@tiptap/starter-kit";
import { Link } from "@tiptap/extension-link";
import { Underline } from "@tiptap/extension-underline";
import { Placeholder } from "@tiptap/extension-placeholder";
import { BackgroundColor } from "./forms/tiptap/background-color.js";
import Table from "@tiptap/extension-table";
import TableCell from "@tiptap/extension-table-cell";
import TableHeader from "@tiptap/extension-table-header";
import TableRow from "@tiptap/extension-table-row";

import TextStyle from "@tiptap/extension-text-style";
import Color from "@tiptap/extension-color";
import {
    ref,
    onMounted,
    defineEmits,
    reactive,
    defineProps,
    watch,
    onUnmounted,
} from "vue";
import WindowDialog from "./WindowDialog.vue";
const toolbarOptions = [
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
    [{ color: [] }, { background: [] }],
];

const emit = defineEmits(["update:modelValue"]);

const props = defineProps({
    isOpen: { type: Boolean, default: false },
    modelValue: { type: String, default: "" },
    meetingCode: { type: String },
    play: { type: Object, default: null },
    isWarRoom: { type: Boolean, default: false },
});

const editor = useEditor({
    editable: true,
    extensions: [
        StarterKit,
        Underline.configure({}),
        Placeholder.configure({
            placeholder: "Play notes..",
        }),
        Link.configure({
            openOnClick: true,
            HTMLAttributes: {
                class: "text-blue-500 hover:underline",
            },
        }),
        Table.configure({
            // resizable: true,
            HTMLAttributes: {
                class: "table-auto border-collapse border border-slate-400 w-full",
            },
        }),
        TableCell.configure({
            HTMLAttributes: {
                class: "border border-slate-300",
            },
        }),
        TableHeader.configure({
            HTMLAttributes: {
                class: "border border-slate-300",
            },
        }),
        TableRow,
        TextStyle,
        Color,
        BackgroundColor,
    ],
    editorProps: {
        attributes: {
            class: "outline-none",
        },
    },
    onUpdate: ({ editor }) => {
        onNoteChange(editor.getHTML());
    },
    content: props.modelValue,
});

const options = {
    theme: "snow", // If you need Quill theme
    modules: {
        toolbar: toolbarOptions,
    },
    placeholder: "Play notes..",
    readOnly: false,
    isUpdating: false,
};
const state = reactive({
    isFirstTime: true,
    model: props.play ? props.play.play_note : props.notes,
    saveText: "",
    isPlay: !!props.play,
    internalValue: props.modelValue,
});

watch(
    () => props.modelValue,
    (newValue, oldValue) => {
        if (newValue === state.internalValue) {
            return;
        }
        editor?.value?.commands?.setContent(newValue);
    }
);

let saveTimeout = null;
function onNoteChange(value) {
    if (state.isFirstTime) {
        state.isFirstTime = false;
        return;
    }
    if (state.isUpdating) {
        return;
    }
    if (!value) {
        value = "";
    }
    state.internalValue = value;

    emit("update:modelValue", value);

    if (props.isWarRoom && !saveTimeout) {
        saveTimeout = setTimeout(async function () {
            await savePlayNotes();
            saveTimeout = null;
        }, 2000);
    }
}

onMounted(() => {});

async function savePlayNotes() {
    try {
        state.saveText = "Saving...";
        if (state.isPlay) {
            await axios.post("/plays/save-notes", {
                notes: props.modelValue,
                play_id: props.play.play_id,
            });
        } else {
            await axios.post("/meeting/save-notes", {
                notes: props.modelValue,
                code: props.meetingCode,
            });
        }
    } catch (e) {
        console.error(e);
    }

    setTimeout(() => {
        state.saveText = "";
    }, 1000);

    state.saveText = "Saved";
}
</script>

<style>
#editor-container {
    max-height: 334px;
    padding: 10px;
    font-size: 13px;
    overflow-y: scroll;
}

#editor-container :first-child {
    margin-top: 0;
}

/* List styles */
#editor-container ul,
#editor-container ol {
    line-height: 1;
    padding: 0 1rem;
    margin: 0.4rem;
}

#editor-container ul {
    list-style-type: disc;
}

#editor-container ol {
    list-style-type: decimal;
}

#editor-container li p {
    margin-top: 0.25em;
    margin-bottom: 0.25em;
}

#editor-container * {
    border-color: #ccc;
}

#editor-container > div > div {
    min-height: 334px;
}
#toolbar {
    padding: 8px;
    border-bottom: 1px solid #ccc;
}

#toolbar > * {
    padding: 3px;
}

#toolbar > *.is-active {
    background: #e2f3fb;
}
</style>
